import React from "react";
import moment from "moment";
import { TableTitle } from "../../../components/Component";
import { TIME_FORMAT_GLOBAL } from "../../../utils";

const signatureSrc = (signature) => {
  if (!signature) return "";
  if (typeof signature === "string") return signature;
  return signature.fileUrl || signature.imageUrl || signature.thumbUrl || "";
};

const SignatureCell = ({ signature }) => {
  const src = signatureSrc(signature);
  if (!src) return <span>-</span>;
  return (
    <img src={src} alt="Signature" style={{ width: "96px", height: "36px", objectFit: "contain" }} />
  );
};

const REPORT_DATE_FORMAT = "DD/MM/YYYY";
const REPORT_DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm a";

const formatTime = (value) => (value ? moment(value).format(TIME_FORMAT_GLOBAL) : "-");

const formatDate = (value) => (value ? moment(value).format(REPORT_DATE_FORMAT) : "-");

const formatDateTime = (value) => (value ? moment(value).format(REPORT_DATE_TIME_FORMAT) : "-");

const formatBreak = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }
  return value;
};

const signatureBlockStyle = { padding: "10px 8px" };
const signatureDateStyle = { marginTop: "8px", whiteSpace: "nowrap" };

const CarerSignatureCell = ({ signature }) => {
  if (!signatureSrc(signature) && !signature?.updatedAt) return <span>-</span>;

  return (
    <div style={signatureBlockStyle}>
      <SignatureCell signature={signature} />
      <div style={signatureDateStyle}>{formatDateTime(signature?.updatedAt)}</div>
    </div>
  );
};

const supervisorSignedAt = (row) =>
  row?.supervisorData?.updatedAt ||
  row?.supervisorData?.clientSignature?.updatedAt ||
  row?.supervisorSignature?.updatedAt;

const SupervisorCell = ({ row }) => {
  const signature = row?.supervisorData?.clientSignature;
  const signedAt = supervisorSignedAt(row);
  if (!signatureSrc(signature) && !signedAt) return <span>-</span>;

  return (
    <div style={signatureBlockStyle}>
      <SignatureCell signature={signature} />
      <div style={signatureDateStyle}>{formatDateTime(signedAt)}</div>
    </div>
  );
};

export const timesheetReportColumns = () => {
  return [
    {
      name: <TableTitle title={"Client"} />,
      id: "client",
      sortable: false,
      minWidth: "140px",
      grow: 1,
      cell: (row) => row?.client?.name || "-",
    },
    {
      name: <TableTitle title={"Date"} />,
      id: "date",
      sortable: false,
      width: "110px",
      cell: (row) => formatDate(row?.timesheetDate),
    },
    {
      name: <TableTitle title={"Start Time"} />,
      id: "startTime",
      sortable: false,
      width: "110px",
      cell: (row) => formatTime(row?.startTime),
    },
    {
      name: <TableTitle title={"End Time"} />,
      id: "endTime",
      sortable: false,
      width: "100px",
      cell: (row) => formatTime(row?.endTime),
    },
    {
      name: <TableTitle title={"Break"} />,
      id: "breakTime",
      sortable: false,
      width: "80px",
      grow: 0,
      cell: (row) => formatBreak(row?.breakTime),
    },
    {
      name: <TableTitle title={"Hours"} />,
      id: "totalHours",
      sortable: false,
      width: "80px",
      grow: 0,
      cell: (row) => (row?.totalHours === 0 || row?.totalHours ? row.totalHours : "-"),
    },
    {
      name: <TableTitle title={"Carer"} />,
      id: "carer",
      sortable: false,
      minWidth: "140px",
      grow: 1,
      cell: (row) => {
        const name = `${row?.carer?.firstName || ""} ${row?.carer?.lastName || ""}`.trim();
        return name || "-";
      },
    },
    {
      name: <TableTitle title={"Carer Signature"} />,
      id: "carerSignature",
      sortable: false,
      width: "200px",
      cell: (row) => <CarerSignatureCell signature={row?.carerSignature} />,
    },
    {
      name: <TableTitle title={"Supervisor Name"} />,
      id: "supervisorName",
      sortable: false,
      minWidth: "150px",
      grow: 1,
      cell: (row) => row?.supervisorData?.clientFullName || "-",
    },
    {
      name: <TableTitle title={"Supervisor Signature"} />,
      id: "supervisor",
      sortable: false,
      width: "200px",
      cell: (row) => <SupervisorCell row={row} />,
    },
    {
      name: <TableTitle title={"Ratings"} />,
      id: "ratings",
      sortable: false,
      width: "90px",
      grow: 0,
      cell: (row) => {
        const ratings = row?.supervisorData?.ratings;
        if (ratings === null || ratings === undefined || ratings === "") return "-";
        return ratings;
      },
    },
    {
      name: <TableTitle title={"Comments"} />,
      id: "comments",
      sortable: false,
      minWidth: "180px",
      grow: 1,
      cell: (row) => row?.supervisorData?.comments || "-",
    },
  ];
};
